import { LlmArtifactService } from '@adaptiva/ai/common';
import { UiService } from '@adaptiva/core/ui';
import { BadgeComponentModule } from '@adaptiva/widgets/badge';
import { DrawerComponent } from '@adaptiva/widgets/drawer';
import { IconComponent } from '@adaptiva/widgets/icon';
import { IStateful, IStatefulChange, provideStateful, stateful } from '@adaptiva/widgets/stateful';
import { Component, inject, input, InputSignal, WritableSignal } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { LlmArtifactListComponent } from '../artifact-list';
import { IArtifactViewerState } from './artifact-viewer-state.interface';
import { LlmArtifactRendererComponent } from './renderer';

@Component({
	selector: 'ada-llm-artifact-viewer',
	templateUrl: './artifact-viewer.component.html',
	styleUrl: './artifact-viewer.component.scss',
	imports: [
		BadgeComponentModule,
		DrawerComponent,
		IconComponent,
		LlmArtifactListComponent,
		LlmArtifactRendererComponent,
	],
	providers: [
		provideStateful(() => LlmArtifactViewerComponent)
	],
})
export class LlmArtifactViewerComponent implements IStateful<IArtifactViewerState> {

	public readonly stateKey: InputSignal<string> = input(null, { alias: 'adaStateful' });

	public readonly stateChanges: Subject<IStatefulChange<IArtifactViewerState>> = new Subject();

	public readonly isStateReady: BehaviorSubject<boolean> = new BehaviorSubject(true);

	protected readonly isCollapsed: WritableSignal<boolean> = stateful(this, false);

	protected readonly artifacts: LlmArtifactService = inject(LlmArtifactService);

	protected readonly ui: UiService = inject(UiService);

	public getState(): IArtifactViewerState {
		return {
			isCollapsed: this.isCollapsed()
		};
	}

	public setState(_state: IArtifactViewerState): void {
		this.isCollapsed.set(_state.isCollapsed ?? false);
	}

}
